import { BRANCHASSOCIATIONLIST_SEARCH, BRANCHASSOCIATIONLIST_PAGE } from '../actions/branchassociationlistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [BRANCHASSOCIATIONLIST_SEARCH]: ({ commit }, search) => {
        commit(BRANCHASSOCIATIONLIST_SEARCH, search);
    },
    [BRANCHASSOCIATIONLIST_PAGE]: ({ commit }, page) => {
        commit(BRANCHASSOCIATIONLIST_PAGE, page);
    }
};

const mutations = {
    [BRANCHASSOCIATIONLIST_SEARCH]: (state, search) => {
        state.page = 0;        
        state.search = search;
    },
    [BRANCHASSOCIATIONLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};